<template>
  <div class="row g-0 top-page-bar">
    <div class="col bg-dark">
      <div class="d-flex flex-row py-4 px-4 align-items-center flex-wrap">
        <slot/>
      </div>
    </div>
  </div>
</template>
